import React from 'react';

export default class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.collapsed || true,
    };
  }

  toggleCollapsed = () => {
    this.setState(prevState => ({ collapsed: !prevState.collapsed }));
  };

  render() {
    const { children, ...restProps } = this.props;
    const { collapsed } = this.state;

    if (!Array.isArray(children) || children.length !== 2) {
      throw new Error(
        'Unsupported Parameter: Accordion expects children to be an array of exactly two components.'
      );
    }

    return (
      <div {...restProps}>
        {children.map((child, i) => {
          // only the first child will be able to toggle the accordion
          const props = {
            key: `${child.type.name}_${i}`,
            collapsed,
            toggleCollapsed: i === 0 ? this.toggleCollapsed : undefined,
          };

          if (typeof child === 'function') {
            return React.createElement(child, props);
          }

          if (React.isValidElement(child)) {
            return React.cloneElement(child, props);
          }

          throw new Error(
            `Unsupported Parameter: Accordion expects each child to be a valid react element; got ${typeof child}.`
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/account/components/Accordion/index.js